export var COLS_WIDGET=34;